import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import logo from '../images/laundry-care-logo.png';
import { API } from '../api/axios'; // Adjust the import based on your API setup
const RegisterAndReset = () => {
  const [mode, setMode] = useState('signup'); // 'signup' | 'forgot'
  const [form, setForm] = useState({
    email: '',
    password: '',
  });
  const [errors, setErrors] = useState({});
  const [message, setMessage] = useState('');

  const validate = () => {
    let newErrors = {};
    if (!form.email) newErrors.email = 'Email is required';
    if (mode === 'signup') {
      if (!form.password || form.password.length < 6)
        newErrors.password = 'Password must be at least 6 characters';
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async () => {
    if (!validate()) return;

    try {
      if (mode === 'signup') {
        const username = form.email.split('@')[0];
        const res = await API.post('/auth/local/register', {
          username,
          email: form.email,
          password: form.password,
        });
        setMessage('Signup successful! You can now log in.');
        setTimeout(() => {
          const encodedEmail = encodeURIComponent(form.email);
          window.location.href = `/signin?email=${encodedEmail}`;
        }, 500);
      } else {
        await API.post('/auth/forgot-password', {
          email: form.email,
        });
        setMessage('Password reset link sent to your email.');
      }
    } catch (err) {
      const msg = err.response?.data?.error?.message || 'Something went wrong';
      setMessage(msg);
    }
  };

  return (
    <main className="bg-white">
      <div className="flex items-center justify-center min-h-screen bg-blue-50">
        <div className="flex flex-col after:flex-1">
          <div className="flex items-center justify-center h-16 px-4 mb-4 sm:mb-20">
            <Link className="block" to="/">
              <img className="w-80" src={logo} alt="Laundry Care" />
            </Link>
          </div>
          <div className="w-[400px] mx-auto">
            <div className="text-center">
              <p className="text-blue-500 text-2xl font-semibold my-1">
                {mode === 'signup' ? 'Apply Now' : 'Forgot Password'}
              </p>
              <p className="text-portal-400 mb-5">
                {mode === 'signup'
                  ? 'Create an account to submit your application.'
                  : 'We’ll send you a reset link.'}
              </p>
            </div>

            <div className=" px-8 sm:px-10 py-8 sm:py-10 mx-5 sm:mx-1 shadow-2xl border border-slate-200 rounded-lg bg-white">
              {message && (
                <div className="text-green-600 text-sm mb-4 text-center">
                  {message}
                </div>
              )}
              <div className="space-y-6">
                {/* {mode === 'signup' && (
                  <div>
                    <label className="block font-medium mb-1">Username</label>
                    <input
                      className={`form-input w-full bg-slate-50 border-0 rounded-lg ${
                        errors.username ? 'border border-red-500' : ''
                      }`}
                      type="text"
                      placeholder="JohnDoe"
                      value={form.username}
                      onChange={(e) =>
                        setForm({ ...form, username: e.target.value })
                      }
                    />
                    {errors.username && (
                      <div className="text-red-500 text-xs mt-1">
                        {errors.username}
                      </div>
                    )}
                  </div>
                )} */}

                <div>
                  <label className="block font-medium mb-1">Email</label>
                  <input
                    className={`form-input w-full bg-slate-50 border-0 rounded-lg ${
                      errors.email ? 'border border-red-500' : ''
                    }`}
                    type="email"
                    placeholder="example@gmail.com"
                    value={form.email}
                    onChange={(e) =>
                      setForm({ ...form, email: e.target.value })
                    }
                  />
                  {errors.email && (
                    <div className="text-red-500 text-xs mt-1">
                      {errors.email}
                    </div>
                  )}
                </div>

                {mode === 'signup' && (
                  <div>
                    <label className="block font-medium mb-1">Password</label>
                    <input
                      className={`form-input w-full bg-slate-50 border-0 rounded-lg ${
                        errors.password ? 'border border-red-500' : ''
                      }`}
                      type="password"
                      placeholder="********"
                      value={form.password}
                      onChange={(e) =>
                        setForm({ ...form, password: e.target.value })
                      }
                    />
                    {errors.password && (
                      <div className="text-red-500 text-xs mt-1">
                        {errors.password}
                      </div>
                    )}
                  </div>
                )}
              </div>
              {mode === 'signup' && (
                <p className="text-slate-700 mt-5 text-xs">
                  By registering, you agree to our{' '}
                  <a
                    className="text-portal-600"
                    href="https://www.laundrycare.biz/privacy/">
                    Privacy Policy
                  </a>{' '}
                  and consent to the processing of your information for
                  application purposes.
                </p>
              )}
              <div className="flex flex-wrap my-6">
                <div className="w-full">
                  <button
                    type="button"
                    onClick={handleSubmit}
                    className="btn py-2.5 text-md font-semibold text-white bg-blue-500 hover:bg-blue-700 w-full rounded-full">
                    {mode === 'signup' ? 'Create Account' : 'Send Reset Link'}
                  </button>
                </div>
              </div>

              <div className="pt-5 mt-6 flex justify-center">
                {mode === 'signup' ? (
                  <p className="text-md">
                    Already have an account?{' '}
                    <Link
                      to="/login"
                      className="font-semibold text-blue-500 hover:text-blue-800">
                      Log in
                    </Link>
                  </p>
                ) : (
                  <p className="text-md">
                    Go back to{' '}
                    <span
                      className="font-semibold text-blue-500 hover:text-blue-800 cursor-pointer"
                      onClick={() => setMode('signup')}>
                      Sign Up
                    </span>
                  </p>
                )}
              </div>

              {mode === 'signup' && (
                <div className="pt-2 mt-2 text-center">
                  <p
                    className="font-semibold text-md text-blue-500 hover:text-blue-800 cursor-pointer"
                    onClick={() => setMode('forgot')}>
                    Forgot password?
                  </p>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </main>
  );
};

export default RegisterAndReset;
